"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var presets;
            (function (presets) {
                function init() {
                    addEvents();
                }
                presets.init = init;
                function addEvents() {
                    $(document).on('hidden.bs.modal', function () {
                        if (appn.iframe.getHost().reloadFlag)
                            appn.location.reloadCurrentPage();
                    });
                }
            })(presets = tasks.presets || (tasks.presets = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
